import { render, staticRenderFns } from "./KZGKanban.vue?vue&type=template&id=285dc850"
import script from "./KZGKanban.vue?vue&type=script&lang=js"
export * from "./KZGKanban.vue?vue&type=script&lang=js"
import style0 from "./KZGKanban.vue?vue&type=style&index=0&id=285dc850&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports